import {
  DEFAULT_AGE_QUOTA_CRITERIA,
  FeasibilityCriterion,
  QUALIFICATION_CODE,
  SurveyQualification,
} from '@ps/survey-utils';

export class FeasibilityCriteriaMapper {
  constructor(public readonly qualifications: SurveyQualification[]) {}

  public map(): FeasibilityCriterion[] {
    const criteria = this.qualifications
      .filter((qualification) => !qualification.isDefault)
      .filter((qualification) => qualification.qualificationName !== 'Location')
      .map((qualification) => this._toCriterion(qualification));

    const hasAgeCriterion = criteria.some(
      (criterion) => criterion.qualificationCode === QUALIFICATION_CODE.AGE,
    );

    return hasAgeCriterion
      ? criteria
      : [...criteria, this._defaultAgeCriterion()];
  }

  private _toCriterion(
    qualification: SurveyQualification,
  ): FeasibilityCriterion {
    if (qualification.isRangeType) {
      return {
        qualificationCode: qualification.qualificationCode,
        qualificationName: qualification.qualificationName,
        rangeSets: qualification.rangeSets,
      };
    }

    return {
      qualificationCode: qualification.qualificationCode,
      qualificationName: qualification.qualificationName,
      conditionCodes: qualification.conditionCodes,
      conditionNames: qualification.data.map((datum) => datum.name),
    };
  }

  private _defaultAgeCriterion(): FeasibilityCriterion {
    return {
      qualificationCode: QUALIFICATION_CODE.AGE,
      qualificationName: DEFAULT_AGE_QUOTA_CRITERIA.NAME,
      rangeSets: [
        {
          from: DEFAULT_AGE_QUOTA_CRITERIA.MIN,
          to: DEFAULT_AGE_QUOTA_CRITERIA.MAX,
          units: DEFAULT_AGE_QUOTA_CRITERIA.UNITS,
        },
      ],
    };
  }
}
